import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import authService from '@/services/auth';
import authStore from '@/store/auth';

export function useLogout() {
  const router = useRouter();
  const store = useStore();

  const logout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      // Logout error — clear local state regardless
    } finally {
      authService.setAuthToken(null);
      authStore.setAuth(false, null);

      store.commit('savedJobs/SET_SAVED_JOBS', []);
      localStorage.removeItem('savedJobs');

      router.push('/login');
    }
  };

  return { logout };
}
